function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128px",
    height: "128px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.983
    },
    fill: "#042b62",
    d: "M 127.5,59.5 C 127.5,62.1667 127.5,64.8333 127.5,67.5C 125.931,70.2284 123.598,72.0617 120.5,73C 90.8333,73.3333 61.1667,73.6667 31.5,74C 34.6657,76.0001 37.3324,78.5001 39.5,81.5C 40.0798,83.7488 41.4131,85.4154 43.5,86.5C 47.8918,91.8943 52.8918,96.561 58.5,100.5C 63.6289,104.452 64.7956,109.452 62,115.5C 58.6621,118.318 54.8288,119.151 50.5,118C 49.0577,117.623 48.0577,116.79 47.5,115.5C 36.8813,103.366 25.3813,91.3657 13,79.5C 12.6012,79.7284 12.4346,80.0618 12.5,80.5C 10.5,79.1667 8.83333,77.5 7.5,75.5C 7.93822,75.5654 8.27155,75.3988 8.5,75C 6.55878,72.5464 4.22545,70.713 1.5,69.5C 0.833333,68.8333 0.166667,68.1667 -0.5,67.5C -0.5,64.5 -0.5,61.5 -0.5,58.5C 0.166667,58.1667 0.833333,57.8333 1.5,57.5C 17.5813,42.9213 33.248,27.7546 48.5,12C 48.2716,11.6012 47.9382,11.4346 47.5,11.5C 47.9528,10.5416 48.6195,9.7083 49.5,9C 60.1618,6.66434 64.6618,10.831 63,21.5C 53.1667,32.6667 42.6667,43.1667 31.5,53C 60.8333,53.3333 90.1667,53.6667 119.5,54C 123.146,54.4898 125.813,56.3231 127.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#8b6f98",
    d: "M 47.5,11.5 C 47.9382,11.4346 48.2716,11.6012 48.5,12C 33.248,27.7546 17.5813,42.9213 1.5,57.5C 16.5,41.8333 31.8333,26.5 47.5,11.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#afefb3",
    d: "M 1.5,69.5 C 4.22545,70.713 6.55878,72.5464 8.5,75C 8.27155,75.3988 7.93822,75.5654 7.5,75.5C 5.16667,73.8333 3.16667,71.8333 1.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.271
    },
    fill: "#b3efb8",
    d: "M 47.5,115.5 C 35.5,104.167 23.8333,92.5 12.5,80.5C 12.4346,80.0618 12.6012,79.7284 13,79.5C 25.3813,91.3657 36.8813,103.366 47.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#91ca74",
    d: "M 39.5,81.5 C 41.5,82.8333 43.1667,84.5 44.5,86.5C 44.1667,86.5 43.8333,86.5 43.5,86.5C 41.4131,85.4154 40.0798,83.7488 39.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31
    },
    fill: "#7a5786",
    d: "M 43.5,86.5 C 43.8333,86.5 44.1667,86.5 44.5,86.5C 49.5,90.8333 54.1667,95.5 58.5,100.5C 52.8918,96.561 47.8918,91.8943 43.5,86.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.f38f50cf35423ec5a35471077d5a0c80.svg";
export { ForwardRef as ReactComponent };